import * as tslib_1 from "tslib";
import { Base } from '../base-component';
import { AnalyticsService } from '../../services/analytics.service';
import './reporting-securitisation.component.scss';
var ReportingSecuritisation = /** @class */ (function (_super) {
    tslib_1.__extends(ReportingSecuritisation, _super);
    function ReportingSecuritisation(element, data) {
        var _this = _super.call(this, element) || this;
        _this.data = data;
        return _this;
    }
    ReportingSecuritisation.prototype.init = function () {
        this.json = jsonReportingSecuritisation;
        this.checkboxAgree = this.element.querySelector('input[name=radio__agree]');
        this.selectProgramme = this.element.querySelector('.js-programme');
        this.selectIssuer = this.element.querySelector('.js-issuer');
        this.selectReport = this.element.querySelector('.js-report');
        this.selectPeriod = this.element.querySelector('.js-period');
        this.formGroups = Array.from(this.element.querySelectorAll('.form__group'));
        this.containerResults = this.element.querySelector('.reporting-securitisation__results');
        this.containerItems = this.element.querySelector('.js-items');
        this.buttonRetrieve = this.element.querySelector('.js-retrieve-report');
        this.valid = false;
        this.createOptionsProgramme();
    };
    ReportingSecuritisation.prototype.bindEvents = function () {
        var _this = this;
        this.checkboxAgree.addEventListener('click', function (evt) {
            _this.selectProgramme.removeAttribute('disabled');
            var group = _this.selectProgramme.closest('.form__group');
            group.classList.remove('form__group--invalid');
        });
        this.selectProgramme.addEventListener('change', function (evt) {
            var element = undefined;
            element = evt.target;
            // disabling components
            _this.containerResults.classList.add('d-none');
            _this.selectReport.setAttribute('disabled', '');
            var groupReport = _this.selectReport.closest('.form__group');
            groupReport.classList.add('form__group--invalid');
            _this.selectPeriod.setAttribute('disabled', '');
            var groupPeriod = _this.selectPeriod.closest('.form__group');
            groupPeriod.classList.add('form__group--invalid');
            // enabling component
            _this.selectIssuer.removeAttribute('disabled');
            var group = _this.selectIssuer.closest('.form__group');
            group.classList.remove('form__group--invalid');
            _this.indexProgramme = element.value;
            // add disabled class from button
            _this.buttonRetrieve.classList.add('button--disabled');
            // change values
            _this.indexIssuer = '';
            _this.indexReport = '';
            _this.indexPeriod = '';
            _this.valid = false;
            _this.createOptionsIssuer();
        });
        this.selectIssuer.addEventListener('change', function (evt) {
            var element = undefined;
            element = evt.target;
            // disabling components
            _this.containerResults.classList.add('d-none');
            _this.selectPeriod.setAttribute('disabled', '');
            var groupPeriod = _this.selectPeriod.closest('.form__group');
            groupPeriod.classList.add('form__group--invalid');
            // enabling component
            _this.selectReport.removeAttribute('disabled');
            var group = _this.selectReport.closest('.form__group');
            group.classList.remove('form__group--invalid');
            _this.indexIssuer = element.value;
            // add disabled class from button
            _this.buttonRetrieve.classList.add('button--disabled');
            // change values
            _this.indexReport = '';
            _this.indexPeriod = '';
            _this.valid = false;
            _this.createOptionsReport();
        });
        this.selectReport.addEventListener('change', function (evt) {
            var element = undefined;
            element = evt.target;
            // disabling components
            _this.containerResults.classList.add('d-none');
            // enabling component
            _this.selectPeriod.removeAttribute('disabled');
            var group = _this.selectReport.closest('.form__group');
            group.classList.remove('form__group--invalid');
            _this.indexReport = element.value;
            // add disabled class from button
            _this.buttonRetrieve.classList.add('button--disabled');
            _this.valid = false;
            // change values
            _this.indexPeriod = '';
            _this.valid = false;
            _this.createOptionsPeriod();
        });
        this.selectPeriod.addEventListener('change', function (evt) {
            var element = undefined;
            element = evt.target;
            // disabling components
            _this.containerResults.classList.add('d-none');
            // disabling components
            _this.indexPeriod = element.value;
            // remove disabled class from button
            _this.buttonRetrieve.classList.remove('button--disabled');
            _this.valid = true;
        });
        this.buttonRetrieve.addEventListener('click', function (event) {
            if (_this.valid) {
                _this.createItems();
            }
        });
    };
    ReportingSecuritisation.prototype.createOptionsProgramme = function () {
        var options = "";
        options += "<option value=\"\">Please select</option>";
        for (var index = 0; index < this.json.length; index++) {
            options += "<option value=\"" + index + "\">" + this.json[index].name + "</option>";
        }
        this.selectProgramme.innerHTML = options;
    };
    ReportingSecuritisation.prototype.createOptionsIssuer = function () {
        if (this.indexProgramme !== '') {
            var options = "";
            var issuers = this.json[this.indexProgramme].issuer;
            options += "<option value=\"\">Please select</option>";
            for (var index = 0; index < issuers.length; index++) {
                options += "<option value=\"" + index + "\">" + issuers[index].name + "</option>";
            }
            this.selectIssuer.innerHTML = options;
        }
    };
    ReportingSecuritisation.prototype.createOptionsReport = function () {
        if (this.indexIssuer !== '') {
            var options = "";
            var reports = this.json[this.indexProgramme].issuer[this.indexIssuer].reports;
            options += "<option value=\"\">Please select</option>";
            for (var index = 0; index < reports.length; index++) {
                options += "<option value=\"" + index + "\">" + reports[index].name + "</option>";
            }
            this.selectReport.innerHTML = options;
        }
    };
    ReportingSecuritisation.prototype.createOptionsPeriod = function () {
        if (this.indexReport !== '') {
            var options = "";
            var periods = this.json[this.indexProgramme].issuer[this.indexIssuer].reports[this.indexReport].periods;
            options += "<option value=\"\">Please select</option>";
            for (var index = 0; index < periods.length; index++) {
                options += "<option value=\"" + index + "\">" + periods[index].name + "</option>";
            }
            this.selectPeriod.innerHTML = options;
        }
    };
    ReportingSecuritisation.prototype.createItems = function () {
        if (this.indexPeriod !== '') {
            var layout = "";
            var files = this.json[this.indexProgramme].issuer[this.indexIssuer].reports[this.indexReport].periods[this.indexPeriod].files;
            for (var index = 0; index < files.length; index++) {
                layout += "<div class=\"file-list-filter-none__item--v2\">\n\n                <div class=\"file-list-filter-none__item--v2__main\">\n                    \n                    <div class=\"file-list-filter-none__item--v2__description\">\n\n                        <div class=\"file-list-filter-none__item--v2__description--title\">\n\n                            <a href=\"" + files[index].urlOpen + "\" download> \n                    \n\t\t\t\t\t\t\t\t" + files[index].name + "\n\n                            </a>\n\n                        </div>\n\n                        <div class=\"file-list-filter-none__item--v2__description--description\">\n\n\t\t\t\t\t\t" + files[index].description + "\n\n                        </div>\n\n                    </div>\n\n                    <div class=\"file-list-filter-none__item--v2__meta\">\n\n                        <div class=\"file-list-filter-none__item--v2__meta--value\">\n\n\t\t\t\t\t\t\t" + files[index].format + "\n                            \n                        </div>\n                        \n                    </div>\n                    \n                    <div class=\"file-list-filter-none__item--v2__description--tablet\">\n\n                        <div class=\"file-list-filter-none__item--v2__description--description\">\n\n\t\t\t\t\t\t\t" + files[index].description + "\n\n                        </div>\n\n                    </div>\n\n                </div>\n\n                <div class=\"file-list-filter-none__item--v2__button\">\n\n                    <a href=\"" + files[index].urlDownload + "\" target=\"_blank\">\n\n\t\t\t\t\t\t<i data-component=\"icon\" data-icon=\"icon-download\" data-gradient=\"\" data-path=\"/file_source/assets/icons/\" class=\"icon file-list-filter-none__icon\"><!--?xml version=\"1.0\" encoding=\"UTF-8\"?--><svg xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" width=\"34px\" height=\"34px\" viewBox=\"0 0 34 34\" version=\"1.1\">\n\t\t\t\t\t\t\t<!-- Generator: Sketch 48.1 (47250) - http://www.bohemiancoding.com/sketch -->\n\t\t\t\t\t\t\t<title>icon-download</title>\n\t\t\t\t\t\t\t<desc>Created with Sketch.</desc>\n\t\t\t\t\t\t\t<defs><linearGradient xy=\"100%\" id=\"gradient\"><stop stop-color=\"#fff\" offset=\"0%\"></stop><stop stop-color=\"#fff\" offset=\"100%\"></stop></linearGradient></defs>\n\t\t\t\t\t\t\t<g id=\"Standard-Bank---Icon-Setup\" stroke=\"none\" stroke-width=\"1\" fill=\"none\" fill-rule=\"evenodd\" transform=\"translate(-499.000000, -1040.000000)\">\n\t\t\t\t\t\t\t\t<g id=\"icon-download\" transform=\"translate(499.000000, 1040.000000)\" fill=\"#0089FF\" fill-rule=\"nonzero\">\n\t\t\t\t\t\t\t\t\t<path d=\"M0,34 L34,34 L34,31.1666667 L0,31.1666667 L0,34 Z M31.1666667,11.3333333 L29.1635,9.3301667 L18.4166667,20.077 L18.4166667,0 L15.5833333,0 L15.5833333,20.077 L4.8365,9.3301667 L2.8333333,11.3333333 L17,25.5 L31.1666667,11.3333333 Z\" id=\"Fill-1-Copy-3\"></path>\n\t\t\t\t\t\t\t\t</g>\n\t\t\t\t\t\t\t\t</g>\n\t\t\t\t\t\t\t</svg>\n\t\t\t\t\t\t</i>\n\n                    </a>\n\n                </div>\n\n            </div>";
            }
            this.containerResults.classList.remove('d-none');
            this.containerItems.innerHTML = layout;
            // Analytics Form Complete 
            var analyticsService = new AnalyticsService();
            analyticsService.dtmFormComplete('complete', '');
        }
    };
    return ReportingSecuritisation;
}(Base));
export { ReportingSecuritisation };



//////////////////
// WEBPACK FOOTER
// ./components/reporting-securitisation/reporting-securitisation.component.ts
// module id = 476
// module chunks = 0